import React from 'react';
import NextImage from 'common/components/NextImage';
import Heading from 'common/components/Heading';
import FeatureBlock from 'common/components/FeatureBlock';
import SectionWrapper, { ThumbWrapper, TextWrapper } from './wolrdwide-distributers.style';
import Link from 'compat/Link';
import { Card, Image, Text, Badge, Button, Group, Box, Grid, Col, Header, Stack, Paper, Container } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';

import { Worldwide } from 'common/data/AppCreative';
import { fontSize, textAlign } from 'styled-system';

const WolrdwideDistributers = () => {
  const { title, thumb, distributers, join } = Worldwide;
  return (
    <Box style={{ maxWidth: 1000, margin: 'auto', padding: '1.5rem', borderRadius: '8px', backgroundColor: 'white' }}>
      <Heading as={'h1'} content={title} style={{ textAlign: 'center' }} />
      <Grid gutter={50} justify="center" align="center">
        <Col xs={0} sm={7}>
          <Image
            radius="md"
            src={thumb}
          />
        </Col>
        <Col xs={12} sm={5}>
          <Stack>
            {distributers.map((item) => (
              <Card key={item.id} shadow="sm" padding="lg" radius="lg">
                <Group position="apart" align="center" noWrap>
                  <Box>
                    <Group mb="xs" noWrap>
                      <Text fw={500} size={'xl'} style={{ whiteSpace: 'nowrap' }}>{item.title}</Text>
                      {!item.status && (
                        <Badge color="orange" style={{ flexShrink: 0 }}>Coming Soon</Badge>
                      )}
                    </Group>
                    <Group >
                      <Text size='md' c="dimmed" weight={'bold'} >
                        {item.contactName}
                      </Text>

                      <Text size="sm" c="dimmed">
                        {item.position}
                      </Text>
                    </Group>
                    <Text size="sm" c="dimmed">
                      {item.company}
                    </Text>
                    <Text size="sm" c="dimmed">
                      {item.address}
                    </Text>
                    <Text size="sm" c="dimmed">
                      {item.phone}
                    </Text>
                    {item.cell && (
                      <Text size="sm" c="dimmed">
                        Cell: {item.cell}
                      </Text>
                    )}
                    <Text size="sm" c="dimmed">
                      <a href={`mailto:${item.email}`} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
                        {item.email}
                      </a>
                    </Text>
                    {item.website && (
                      <Text size="sm" c="dimmed">
                        <a href={item.website.startsWith('http') ? item.website : `https://${item.website}`} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
                          {item.website}
                        </a>
                      </Text>
                    )}
                  </Box>
                  {item.logo && (
                    <Image
                      src={item.logo}
                      alt={item.contactName}
                      fit="contain"
                      width={120}
                      height={64}
                      style={{ flexShrink: 0 }}
                    />
                  )}
                </Group>
                {/* <Button color="blue" fullWidth mt="md" radius="md">
                  Book classic tour now
                </Button> */}
              </Card>
              // <FeatureBlock
              //   key={`app-feature--key${item.id}`}
              //   iconPosition="left"
              //   icon={<Text as="span" content={'0' + item.id} />}
              //   title={<Heading as="h3" content={item.title}/>}
              //   description={<Text style={{whiteSpace: 'pre-wrap'}} content={item.description} />}
              // />
            ))}
            <Link key={'contact_dist_action'} href={'/become-partner'}>
              <Button
                fullWidth
                variant='subtle'
                color='dark'
                rightIcon={<IconArrowRight size={16} stroke={2} />}
              >
                {join}
              </Button>
            </Link>

          </Stack>

        </Col>
      </Grid>
    </Box>

  );
};

export default WolrdwideDistributers;
